
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="applyFilter($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <span (click)="goToSendInvitation()" class="cursorClass"><i class="ti ti-plus"
                    *ngIf="userTypeId == 1"></i></span>
        </div>
    </div>
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center" [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChanged($event)">
        <mat-tab label="આમંત્રિત સભ્યો">
            <div class="main-members family-tabs">
                <a *ngFor="let member of getInvitedMemberList" class="member-list-item">
                    <div>
                        <div class="d-flex align-items-center justify-content-between">
                            <h5>{{ member.member_name}}</h5>                        
                            <span >
                                <i class="ti ti-check" (click)="CheckActive(member)"></i>
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </mat-tab>

        <!-- <mat-tab label="હાજર સભ્યો" *ngIf="userTypeId == 1">
            <div class="main-members family-tabs">
                <div *ngFor="let member of getPresentMember" class="mb-4 pb-3 border-bottom">
                    <h5>{{ member.member_name }}</h5>
                    <small class="text-success">હાજર તારીખ અને સમય : {{member.attendance_time | date: 'dd/MM/yyyy hh:mm:ss'}} </small>
                </div>
            </div>
        </mat-tab> -->
    </mat-tab-group>
</main>